import { ROUTES } from '@/shared/config'
import { navigateToFx } from '@/shared/lib/providers'
import {
  $lastCreatedAlbumCollectionId,
  AlbumCollectionFormTabsKeys,
  lastCreatedAlbumCollectionIdReset,
} from '@/widgets/AlbumCollectionForm'
import { $albumCollectionCommonInformationFormInitialAuthor } from '@/widgets/AlbumCollectionForm'
import { createEvent, sample } from 'effector'
import { createGate } from 'effector-react'
import { type NavigateOptions } from 'react-router-dom'

export const AlbumCollectionCreatePageGate = createGate()
const navigateToEditCollectionFx = createEvent<string>()
sample({
  clock: [$lastCreatedAlbumCollectionId, AlbumCollectionCreatePageGate.open],
  source: $lastCreatedAlbumCollectionId,
  filter: (id): id is string => typeof id === 'string',
  target: navigateToEditCollectionFx,
})
sample({
  source: $albumCollectionCommonInformationFormInitialAuthor,
  clock: navigateToEditCollectionFx,
  fn: (author, id) => ({
    to: ROUTES.COLLECTIONS.EDIT_ALBUM_COLLECTION.replace(':id', id),
    options: {
      state: {
        activeTab: AlbumCollectionFormTabsKeys.Albums,
        author,
      },
    } as NavigateOptions,
  }),
  target: [navigateToFx, lastCreatedAlbumCollectionIdReset],
})
